import { useEffect, useRef, useState } from 'react';
import { Animated } from 'react-native';

export function useFadeOut(shouldShow: boolean, duration = 200) {
  const opacity = useRef(new Animated.Value(1)).current;
  const [isVisible, setIsVisible] = useState(shouldShow);

  useEffect(() => {
    if (shouldShow) {
      opacity.setValue(1);
      setIsVisible(true);
      return;
    }

    if (!isVisible) {
      return;
    }

    Animated.timing(opacity, {
      toValue: 0,
      duration,
      useNativeDriver: true,
    }).start(({ finished }) => {
      if (finished) {
        setIsVisible(false);
      }
    });
  }, [shouldShow, isVisible, duration, opacity]);

  return { opacity, isVisible };
}
